var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticStyle: { width: "100%", height: "100%", padding: "20px" } },
    [
      _c("div", { staticClass: "welcome" }, [
        _vm._v(" " + _vm._s(_vm.$t("home.welcomeanjunKD")) + " "),
      ]),
      _c("div", { staticClass: "favorites" }, [
        _c("div", { staticClass: "flx-between" }, [
          _c(
            "div",
            { staticStyle: { "font-size": "20px", "font-weight": "bold" } },
            [_vm._v(_vm._s(_vm.$t("home.funcFavorites")))]
          ),
          _c(
            "div",
            {
              staticClass: "point",
              on: { click: _vm.showSetFavoritesItemDialog },
            },
            [
              _c("i", {
                staticClass: "el-icon-setting",
                staticStyle: { "font-size": "25px" },
              }),
            ]
          ),
        ]),
        _c(
          "div",
          [
            _c(
              "draggable",
              {
                staticClass: "flex-start favoritesList",
                attrs: {
                  animation: "100",
                  "chosen-class": "chosen",
                  "drag-class": "tag-drag",
                  "ghost-class": "tag-ghost",
                  "item-key": "id",
                },
                on: { change: _vm.draggableChange },
                model: {
                  value: _vm.searchMenuList,
                  callback: function ($$v) {
                    _vm.searchMenuList = $$v
                  },
                  expression: "searchMenuList",
                },
              },
              _vm._l(_vm.searchMenuList, function (i, index) {
                return _c(
                  "div",
                  {
                    key: index,
                    staticClass: "favoritesItem",
                    on: {
                      click: function ($event) {
                        return _vm.toMenu(i)
                      },
                    },
                  },
                  [
                    _c("span", { staticClass: "favoritesName" }, [
                      _vm._v(_vm._s(i.name)),
                    ]),
                  ]
                )
              }),
              0
            ),
          ],
          1
        ),
      ]),
      _c(
        "div",
        {
          staticClass: "favorites",
          staticStyle: { height: "580px", overflow: "auto" },
        },
        [
          _c(
            "div",
            {
              staticStyle: {
                "margin-bottom": "10px",
                "font-size": "18px",
                "font-weight": "bold",
              },
            },
            [_vm._v(_vm._s(_vm.$t("GlobalSetObj.announcement")))]
          ),
          _c(
            "div",
            [
              _vm._l(
                _vm.messageInfoList.topMessageList,
                function (item, index) {
                  return _c(
                    "div",
                    {
                      key: index,
                      staticClass: "itemInfo",
                      staticStyle: { "margin-bottom": "15px" },
                    },
                    [
                      _c(
                        "div",
                        { staticClass: "infoTag" },
                        [
                          _c("el-tag", { attrs: { type: "danger" } }, [
                            _vm._v(_vm._s(_vm.$t("home.pinToTop"))),
                          ]),
                        ],
                        1
                      ),
                      _c("div", [
                        _c("i", {
                          staticClass: "iconfont icon-gonggao",
                          staticStyle: { "font-size": "16px" },
                        }),
                        _c(
                          "span",
                          {
                            staticStyle: {
                              "margin-left": "10px",
                              color: "#777777",
                            },
                          },
                          [_vm._v(_vm._s(item.createTime))]
                        ),
                      ]),
                      _c(
                        "div",
                        {
                          staticClass: "infoTitleItem",
                          staticStyle: {
                            color: "#409eff !important",
                            margin: "5px 0 7px 25px",
                            "font-weight": "bold",
                            "font-size": "18px",
                          },
                        },
                        [_vm._v(" " + _vm._s(item.title) + " ")]
                      ),
                      _c("div", {
                        staticStyle: { "margin-left": "25px" },
                        domProps: { innerHTML: _vm._s(item.messageContent) },
                        on: {
                          click: function ($event) {
                            $event.stopPropagation()
                            return _vm.getImgSrc($event)
                          },
                        },
                      }),
                    ]
                  )
                }
              ),
              _vm._l(
                _vm.messageInfoList.normalMessageList,
                function (item, index) {
                  return _c(
                    "div",
                    {
                      key: index,
                      staticClass: "itemInfo",
                      staticStyle: { "margin-bottom": "15px" },
                    },
                    [
                      _c("div", [
                        _c("i", {
                          staticClass: "iconfont icon-gonggao",
                          staticStyle: { "font-size": "16px" },
                        }),
                        _c(
                          "span",
                          {
                            staticStyle: {
                              "margin-left": "10px",
                              color: "#777777",
                            },
                          },
                          [_vm._v(_vm._s(item.createTime))]
                        ),
                      ]),
                      _c(
                        "div",
                        {
                          staticClass: "infoTitleItem",
                          staticStyle: {
                            color: "#409eff !important",
                            margin: "5px 0 7px 25px",
                            "font-weight": "bold",
                            "font-size": "18px",
                          },
                        },
                        [_vm._v(" " + _vm._s(item.title) + " ")]
                      ),
                      _c("div", {
                        staticStyle: { "margin-left": "25px" },
                        domProps: { innerHTML: _vm._s(item.messageContent) },
                        on: {
                          click: function ($event) {
                            $event.stopPropagation()
                            return _vm.getImgSrc($event)
                          },
                        },
                      }),
                    ]
                  )
                }
              ),
            ],
            2
          ),
        ]
      ),
      _c("favorites", {
        ref: "favoritesRef",
        attrs: {
          "pc-menu-list": _vm.menuList,
          "show-menu-list": _vm.searchMenuList,
        },
        on: { childrenSearch: _vm.childrenSearch },
      }),
      _c(
        "el-dialog",
        {
          attrs: {
            "close-on-click-modal": false,
            "close-on-press-escape": false,
            "show-close": false,
            title: _vm.$t("login.changePwd"),
            visible: _vm.centerDialogVisible,
            center: "",
            width: "500px",
          },
          on: {
            "update:visible": function ($event) {
              _vm.centerDialogVisible = $event
            },
          },
        },
        [
          _c("p", { staticClass: "color-DF303A" }, [
            _vm._v(_vm._s(_vm.$t("GlobalSetObj.changePasswordMonth"))),
          ]),
          _c(
            "el-form",
            {
              ref: "ruleForm",
              attrs: {
                model: _vm.ruleForm,
                rules: _vm.rules,
                "label-width": "100px",
              },
            },
            [
              _c(
                "el-form-item",
                {
                  attrs: {
                    label: _vm.$t("changepwd.oldPwd"),
                    prop: "oldPassword",
                  },
                },
                [
                  _c("el-input", {
                    attrs: {
                      placeholder: _vm.$t("changepwd.inputOldPwd"),
                      "show-password": "",
                    },
                    model: {
                      value: _vm.ruleForm.oldPassword,
                      callback: function ($$v) {
                        _vm.$set(_vm.ruleForm, "oldPassword", $$v)
                      },
                      expression: "ruleForm.oldPassword",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                {
                  attrs: {
                    label: _vm.$t("changepwd.newPwd"),
                    prop: "newPassword",
                  },
                },
                [
                  _c("el-input", {
                    attrs: {
                      placeholder: _vm.$t("changepwd.inputNewPwd"),
                      maxlength: "12",
                      minlength: "8",
                      "show-password": "",
                    },
                    model: {
                      value: _vm.ruleForm.newPassword,
                      callback: function ($$v) {
                        _vm.$set(
                          _vm.ruleForm,
                          "newPassword",
                          typeof $$v === "string" ? $$v.trim() : $$v
                        )
                      },
                      expression: "ruleForm.newPassword",
                    },
                  }),
                  _c("span", { staticClass: "tips" }, [
                    _vm._v(_vm._s(_vm.$t("changepwd.inputHint"))),
                  ]),
                ],
                1
              ),
              _c(
                "el-form-item",
                {
                  attrs: {
                    label: _vm.$t("changepwd.checkPwd"),
                    prop: "newPasswordConfirm",
                  },
                },
                [
                  _c("el-input", {
                    attrs: {
                      placeholder: _vm.$t("changepwd.inputConfirmCode"),
                      maxlength: "12",
                      minlength: "8",
                      "show-password": "",
                    },
                    model: {
                      value: _vm.ruleForm.newPasswordConfirm,
                      callback: function ($$v) {
                        _vm.$set(
                          _vm.ruleForm,
                          "newPasswordConfirm",
                          typeof $$v === "string" ? $$v.trim() : $$v
                        )
                      },
                      expression: "ruleForm.newPasswordConfirm",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                [
                  _c(
                    "el-button",
                    {
                      attrs: { type: "primary" },
                      on: {
                        click: function ($event) {
                          return _vm.submitForm("ruleForm")
                        },
                      },
                    },
                    [_vm._v(_vm._s(_vm.$t("changepwd.confirm")) + " ")]
                  ),
                  _c(
                    "el-button",
                    {
                      on: {
                        click: function ($event) {
                          return _vm.resetForm("ruleForm")
                        },
                      },
                    },
                    [_vm._v(_vm._s(_vm.$t("GlobalSetObj.cancel")))]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm.showViewer
        ? _c("ElImageViewer", {
            attrs: { "on-close": _vm.closeViewer, "url-list": _vm.imgArr },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }